import { WhiteFieldItemTime } from '../styles';
import React, { useEffect, useRef } from 'react';
export var TimeCodeTimeInput = function (props) {
    var item = props.item, index = props.index, onChangeTime = props.onChangeTime, onTimeCodeChange = props.onTimeCodeChange, maxTime = props.maxTime;
    var inputTimeRef = useRef(null);
    /*  useEffect(() => {
        if (!inputTimeRef?.current) return
    
        const inputTime = inputTimeRef.current
        const onClick = () => {
          inputTime.focus()
          inputTime.click()
        }
        inputTime.addEventListener('click', onClick)
        return () => inputTime.removeEventListener('click', onClick)
      }, [inputTimeRef])*/
    return (React.createElement(WhiteFieldItemTime, { ref: inputTimeRef, className: 'time-input', step: '3', type: 'time', min: '00:00:00', max: maxTime, value: item.time, onChange: function (e) {
            return onChangeTime(e.target.value, function (value) {
                return onTimeCodeChange(index, { time: value });
            });
        } }));
};
//# sourceMappingURL=TimeCodeTimeInput.js.mapimport { WhiteFieldItemTime } from '../styles';
import React, { useEffect, useRef } from 'react';
export var TimeCodeTimeInput = function (props) {
    var item = props.item, index = props.index, onChangeTime = props.onChangeTime, onTimeCodeChange = props.onTimeCodeChange, maxTime = props.maxTime;
    var inputTimeRef = useRef(null);
    /*  useEffect(() => {
        if (!inputTimeRef?.current) return
    
        const inputTime = inputTimeRef.current
        const onClick = () => {
          inputTime.focus()
          inputTime.click()
        }
        inputTime.addEventListener('click', onClick)
        return () => inputTime.removeEventListener('click', onClick)
      }, [inputTimeRef])*/
    return (React.createElement(WhiteFieldItemTime, { ref: inputTimeRef, className: 'time-input', step: '3', type: 'time', min: '00:00:00', max: maxTime, value: item.time, onChange: function (e) {
            return onChangeTime(e.target.value, function (value) {
                return onTimeCodeChange(index, { time: value });
            });
        } }));
};
//# sourceMappingURL=TimeCodeTimeInput.js.map